/*
* 性能统计库参考：https://gzgit.mail.netease.com/webmail/tools/performance-monitor
*/
import PerformanceMonitor from '@mail/performance-collector';
import pkg from '../../package.json';

const packageName = pkg.name || '';
var pm = new PerformanceMonitor({
    send(performanceData) {
        if (window.mailStats) {
            window.mailStats.performance(packageName, { performanceData }, 'performance');
        }
    },
    resources: [],
    reportType: {
        navigation: true, // 页面加载
        resource: false, // 资源加载
        memory: true, // 内存情况
    },
    samplingRate: 1,
})
pm.start();
